const guestKey = 'lang_picked_guest';
const userKey = (phone) => `lang_picked_${phone || 'guest'}`;

const getPickedKey = (phone) => (phone ? userKey(phone) : guestKey);

export const hasPicked = (phone) => {
  try {
    return !!localStorage.getItem(getPickedKey(phone));
  } catch {
    return true;
  }
};

export const savePicked = (lang, phone) => {
  try {
    localStorage.setItem(getPickedKey(phone), lang);
    localStorage.setItem(guestKey, lang);
  } catch { }
};
